import * as React from 'react';
import { useContext } from 'react';
import './home.sass';
import { Init } from '../init/init';
import '../../i18n';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { ConfigContext } from '../../hooks/context/config';
import { RestApiClientContext } from 'src/hooks/context/pageContext';
import TagManager from 'react-gtm-module';

// Componente de la vista principal de la aplicación
const Home = () => {
  const restApiClient = useContext(RestApiClientContext);

  // Comprobamos si el cliente tiene configurado el noindex nofollow

  const [gtmId, setGtmId] = React.useState<string>('');
  const getGtmId = () : void => {
    restApiClient.getGtmId().then(v => {
      setGtmId(v);

      if (v.length === 0) return;

      TagManager.initialize({
        gtmId: v
      });
    });
  }

  const [noIndexNoFollow, setNoIndexNoFollow] = React.useState(false);
  const getNoIndexNoFollow = () : void => {
    restApiClient.getNoIndexNoFollowConfig().then(v => {
      setNoIndexNoFollow(v);
    });

  }
  React.useEffect(() => {
    getNoIndexNoFollow();
    getGtmId();
  }, []);


  // Contexto con la configuracion de la app
  const infoClient = useContext(ConfigContext);

  // Lenguaje para los textos
  const { t } = useTranslation('seo');

  

  return (
    <>
      <Helmet>

        {
          noIndexNoFollow ? 
            <meta name="robots" content="noindex, nofollow" />
          : <meta name="robots" content="index,follow" />
        }
        <title>{ infoClient.incentiveSiteName } | { t('seo:title.home') }</title>
        <meta name="description" content={ t('seo:description.home', { 0: infoClient.incentiveSiteName }) } />
        <link rel="canonical" href={ infoClient.urlWA } />
        <link rel="icon" type="image/ico" href={ infoClient.favicon } sizes="32x32" />
        <link href={ infoClient.urlWA } hrefLang="es-ES" rel="alternate" />
      </Helmet>

      <Init/>
    </>
  );
}

export default Home;

